import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';import { register } from 'swiper/element/bundle';
import { StatusBarService } from '@shared';

// Register Swiper web components once globally (avoids duplicated registration across lazy routes)
register();

// Android APK: mark document before bootstrap so .pt-safe keeps status-bar inset.
StatusBarService.applyAndroidSafeAreaFix();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    console.error('Failed to bootstrap application:', err);
    throw err;
  });
